import { userOnboardingAPIToUserOnboarding } from './APITransformer';
import type { UpdateUserOnboarding, UserOnboarding } from './Types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';

export class OnboardingRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public updateOnboarding = (
    onboarding: UpdateUserOnboarding
  ): Promise<UserOnboarding | undefined> => {
    const requestData = {
      endpoint: '/users/onboarding',
      method: HttpMethod.PUT,
      body: JSON.stringify(onboarding),
    };
    return this.requester
      .request(requestData)
      .then((response: any) =>
        userOnboardingAPIToUserOnboarding(response.data)
      );
  };

  public createOnboarding = (): Promise<UserOnboarding | undefined> => {
    const requestData = {
      endpoint: '/users/onboarding',
      method: HttpMethod.POST,
    };
    return this.requester
      .request(requestData)
      .then((response: any) =>
        userOnboardingAPIToUserOnboarding(response.data)
      );
  };

  public resetOnboarding = (): Promise<UserOnboarding | undefined> => {
    const requestData = {
      endpoint: '/users/onboarding/reset',
      method: HttpMethod.PUT,
    };
    return this.requester
      .request(requestData)
      .then((response: any) =>
        userOnboardingAPIToUserOnboarding(response.data)
      );
  };
}

export default OnboardingRequester;
